import { render, staticRenderFns } from "./PublicPageUserMenu.vue?vue&type=template&id=1cf1b17e&scoped=true"
import script from "./PublicPageUserMenu.vue?vue&type=script&lang=ts"
export * from "./PublicPageUserMenu.vue?vue&type=script&lang=ts"
import style0 from "./PublicPageUserMenu.vue?vue&type=style&index=0&id=1cf1b17e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf1b17e",
  null
  
)

export default component.exports